import { render, staticRenderFns } from "./RecruitmentRecruitList.vue?vue&type=template&id=1989881d&scoped=true"
import script from "./RecruitmentRecruitList.vue?vue&type=script&lang=js"
export * from "./RecruitmentRecruitList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1989881d",
  null
  
)

export default component.exports